// People this chat already knows, looked up by name, so "Research Bruna Souza" runs on the
// LinkedIn URL we are already holding instead of a vendor lookup (or, before this existed, a paid
// person search). Three places hold people, checked in this order:
//
//   research_context   the prospect just researched
//   seen_ref           people a named-company search saw and did not pull (name, title, URL)
//   message rows       every contact any earlier search delivered, newest message first
//
// A match needs the full name (case, accents, punctuation and spacing folded) and, when the ask
// named a company, that company too. A match with a URL beats one without; a match without a URL
// is still returned, because its company is what the name lookup needs next.

const foldName = (s) => String(s || '')
  .toLowerCase()
  .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  .replace(/['\u2019]/g, '')
  .replace(/[^a-z0-9]+/g, ' ')
  .trim();

const LEGAL = /\b(inc|llc|l l c|corp|corporation|ltd|limited|co|company|gmbh|plc|sa|ag)\b/g;
const foldCompany = (s) => foldName(s).replace(LEGAL, ' ').replace(/\s+/g, ' ').trim();

// Same company, allowing "Numeral" for "Numeral HQ, Inc.". Either side unknown is no evidence
// against, so it agrees.
export function companyAgrees(a, b) {
  const x = foldCompany(a);
  const y = foldCompany(b);
  if (!x || !y) return true;
  return x === y || x.includes(y) || y.includes(x);
}

const person = (p) => ({
  name:        String(p?.name || '').trim(),
  title:       String(p?.title || '').trim(),
  company:     String(p?.company || '').trim(),
  linkedinUrl: String(p?.linkedinUrl || '').trim(),
});

export function sessionPeople(chat) {
  if (!chat) return [];
  const out = [];
  const rc = chat.research_context;
  if (rc?.name) out.push(person({ name: rc.name, title: rc.title, company: rc.company, linkedinUrl: rc.linkedinUrl }));
  for (const r of [...(chat.seen_ref || [])].reverse()) out.push(person(r));
  for (const m of [...(chat.messages || [])].reverse()) {
    for (const row of (Array.isArray(m?.contacts) ? m.contacts : [])) {
      const c = row?.contact || row;
      if (c?.name) out.push(person(c));
    }
  }
  return out.filter(p => p.name);
}

export function findSessionPerson(chat, name, company = '') {
  const want = foldName(name);
  if (!want) return null;
  const hits = sessionPeople(chat).filter(p => foldName(p.name) === want && (!company || companyAgrees(p.company, company)));
  return hits.find(p => p.linkedinUrl) || hits[0] || null;
}
